export default __webpack_public_path__ + "static/media/img3.1240cd0a.jpg";